/** True when Supabase Auth rejected an email because another account already uses it. */
export function isEmailAlreadyRegisteredError(error: { code?: string; message?: string } | null | undefined): boolean {
    if (!error) return false;
    return error.code === "email_exists" || /already (been )?registered|already exists/i.test(error.message ?? "");
}
